module.exports = __webpack_public_path__ + "static/media/devops_id_logo.4d220e81.png";